import { Card, CardBody, Container, Label, Row, Col, Input, InputGroup, FormGroup, Button, InputGroupText } from "reactstrap";
import { default as ReactSelect } from "react-select";
import ErrorBoundary from "components/ErrorBoundary";
import { Option, LimitedChipsContainer } from 'components/Options';
import { setLocale } from "@withshepherd/faker";
import Confirm from "components/Confirm";
import { forEach, template } from "lodash";
import CoveredEntity from "components/CoveredEntity";
import { toBeRequired } from "@testing-library/jest-dom/matchers";
// import NDCList from "components/NDCList";
import Calendar from 'assets/icon/calendar-icon.svg';
import React, { useState, useEffect } from "react";
import useAxios from "hooks/useAxios";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import { Field, Formik, yupToFormErrors } from 'formik';
import { dateFormate } from 'utils/columns';
import moment from 'moment';
import { toast } from 'react-toastify';
import FormikInputField from "components/common/Fields/FormikInputField";
import FormikSelectField from "components/common/Fields/FormikSelectField";


let addPharmacyConfig = {};
let hasDatePopupOpen = false;
const initialValues = {
  CoveredEntityName: "",

};
let addcoveredentity = {};

const AddPharmacyConfig = (props) => {

  const { searchTerms, refetch, manvalPharmacy, orgId } = props;
  const { organizationID } = orgId

  const [isChecked, setIsChecked] = useState(true);
  const [data, SetData] = useState('');
  // const [endDate, setEndDate] = useState(null);
  // const [saveDisabled, setSaveDisabled] = useState(true);
  const [hideRow, setHideRow] = useState(false);
  const [coveredEntityList, SetCoveredEntityList] = useState([]);
  const [showResultRow, setShowResultRow] = useState(true);
  const [resultData, setResultData] = useState([]);
  const [isConfirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setError] = useState('');
  const [phLiveDate, setPHLiveDate] = useState(null);
  const [CoveredEntityName, setCoveredentityname] = useState("")
  const [opaerror, setOPaError] = useState("")
  const [opa, setOpa] = useState("")
  const [ceError, setCEError] = useState("")
  const [ceTypeError, setCETypeError] = useState("")
  const [CoveredEntityType, setCoveredEntityType] = useState("")
  const [contactName, setcontactName] = useState("")
  const [contactError, setcontactError] = useState("")
  const [phone, setPhone] = useState("")
  const [phoneError, setPhoneError] = useState("")
  const [mail, setMail] = useState("")
  const [address1, setAddress1] = useState("")
  const [address2, setAddress2] = useState("")
  const [zipCode, setZipCode] = useState("")
  const [ext, setExt] = useState("")
  const [fax, setFax] = useState("")
  const [website, setWebsite] = useState("")
  const [tollFreeNo, setTollFreeNo] = useState("")
  const [emailError, setEmailError] = useState("")
  const [zipcodeError, setZipCodeError] = useState("")
  const [Selectedstate, SetSelectedState] = useState("")
  const [selectedCoverEntityType, setSelectedCoverEntityType] = useState("")
  const [cityName, setCityName] = useState("")
  const [state, SetState] = useState([]);
  const [EntityType, setEntityType] = useState([]);
  const [stateData, setStateData] = useState("")


  const handleToggle = () => {
    setIsChecked(!isChecked);
  };
  const API = useAxios();

  let addDisabled = (CoveredEntityName.length == 0 || opa.length == 0 || contactName.length == 0 || address1.length == 0 ||
    phone.length == 0 || mail.length == 0 || zipCode.length == 0 || cityName.length == 0)




  const handleSubmit = async () => {
    // 
    let CoveredEntityList = []
    if (opa.length == 0) {
      setOPaError("Please Enter CoverEntity Name")
    }

    if (CoveredEntityName.length == 0) {
      setCEError("Please Enter OpaID")
    }
    // if (CoveredEntityType.length == 0)
    // {
    //     setCETypeError("Please Enter CoverEntityType")
    // }
    if (contactName.length == 0) {
      setcontactError("Please Enter Contact Name")
    }
    if (phone.length == 0) {
      setPhoneError("Please Enter Phone")
    }
    if (mail.length == 0) {
      setEmailError("Please Enter EmailID")
    }
    if (zipCode == 0) {
      setZipCodeError("Please Enter Zipcode")
    }

    // await addcoveredenttitydetails()
    //   handleSaveConfirmation();
    var lst = {};
    lst.coveredEntityName = CoveredEntityName,
      lst.OPACode = opa,
      lst.CoveredEntityTypeID = selectedCoverEntityType,
      lst.ContactPerson = contactName,
      lst.Phone = phone,
      lst.Ext = ext
    lst.EmailID = mail
    lst.Address1 = address1
    lst.Address2 = address2
    lst.ZipCode = zipCode
    lst.Fax = fax
    lst.Website = website
    lst.TollFreeNo = tollFreeNo
    lst.CityName = cityName
    lst.StateID = Selectedstate
    lst.organizationID = organizationID
    // SetCoveredEntityList(lst)
    CoveredEntityList.push(lst)
    setLoading(true);
    try {
      const result = await API.post(
        'SBConfig/CoveredEntity/AddCoveredEntity', { CoveredEntityList },
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      setLoading(false);
      toast.success('CoverEntity saved successfully');
      if (result) {
        // setResultData(result.data);
        // setHideRow(true);
        // setShowResultRow(false);
        setLoading(false);
        manvalPharmacy()
        refetch(true);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }

  useEffect(() => {
    handelState()
    handleCoverEntityData()
  }, [])


  const handleCoverEntityData = async () => {
    try {
      const { data } = await API.get("SBConfig/TypeStatus/CoveredEntityTypes", {
        hasDefaultURL: true,
      })
    

      if (data) {
        setEntityType(data)
      }
    }
    catch (error) {
      console.log(error)
    }
  }

  const handelState = async () => {
    try {
      const { data } = await API.get("SBConfig/TypeStatus/states", {
        hasDefaultURL: true,
      })
      if (data) {
        SetState(data)
      }
    }
    catch (error) {
      console.log(error)
    }

  }
  const handelcoveredentityname = ({ target: { value } }) => {
    setCoveredentityname(value);
    if (value.length > 0) {
      setCEError("")
    }
    //  addcoveredentity.coveredEntityname = value;   
  }

  const handleOpaid = ({ target: { value } }) => {
    setOpa(value)
    if (value.length > 0) {
      setOPaError("");
    }
    // addcoveredentity.opaid = value;
  }
  const handleContactName = ({ target: { value } }) => {
    setcontactName(value)
    if (value.length > 0) {
      setcontactError("")
    }
  }
  const handlePhone = ({ target: { value } }) => {
    setPhone(value)
    if (value.length > 0) {
      setPhoneError("")
    }
  }
  const handleMailChange = ({ target: { value } }) => {
    setMail(value)
    if (value.length > 0) {
      setEmailError("")
    }
  }
  const handleAddress1 = ({ target: { value } }) => {
    setAddress1(value)
  }

  const handleAddress2 = ({ target: { value } }) => {
    setAddress2(value)
  }
  const handleZipCode = ({ target: { value } }) => {
    setZipCode(value)
    if (value.length > 0) {
      setZipCodeError("")
    }
  }
  const handleExt = ({ target: { value } }) => {
    setExt(value)
  }
  const handleFax = ({ target: { value } }) => {
    setFax(value)
  }
  const handleWebsite = ({ target: { value } }) => {
    setWebsite(value)
  }
  const handleTollFreeNo = ({ target: { value } }) => {
    setTollFreeNo(value)
  }

  const handleCityName = ({ target: { value } }) => {
    setCityName(value)
  }
  const handleStateData = ({ target: { value } }) => {
  
    SetSelectedState(value)
    SetState(value)
  }

  // const handleCoverEntityType = ({target: {value}}) =>{
  //     setCoveredEntityType(value)
  // if(value.length >0){
  //     setCETypeError("")
  // }
  // }

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handlePHLiveDate = (phLiveDate) => {
    let phLDate = dateFormate(phLiveDate);
    setPHLiveDate(phLDate);
    addPharmacyConfig.phLiveDate = moment(new Date(phLiveDate)).format(
      'MM/DD/YYYY'
    );
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }

    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleSaveConfirmation = () => {
    setConfirm(!isConfirm);
  };

  const handleReset = (resetForm) => {
    handleResetChange();
    resetForm();
  };

  const handleCoverEntityType = (e) => {
    const { value } = e.target;
    console.log(value, "value in EntityType")
    setSelectedCoverEntityType(value);
  }

  const handelStateChange = (e) => {

    const { value } = e.target;
    console.log(value, "value in chnage")
    // setFieldValue('PanelType', value);
    SetSelectedState(value);
    // addedPrescriber.panelType = value;
  }



  useEffect(() => {
    handelCancel()
  }, [orgId])

  const handelCancel = () => {

    setCoveredentityname('');
    setOpa("")
    setcontactName("")
    setAddress1("")
    setAddress2("")
    setCityName("")
    setPhone("")
    setExt("")
    setFax("")
    setWebsite("")
    setTollFreeNo("")
    setZipCode("")
    setMail("")
    setSelectedCoverEntityType("")
    setPHLiveDate("")
    SetSelectedState("")

  }

  return (
    <div>
      <Container>
        <Card>
          <CardBody>
            <h4 className='f-15 text-primary font-weight-700'> Covered Entity Information </h4>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              enableReinitialize={true}
              children={(props) => {
                const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                return (
                  <div hidden={""}>
                    <Row sm={5}>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="CoveredEntityName">
                            Covered Entity
                          </Label>
                          <Input
                            id="CoveredEntityName"
                            name="CoveredEntityName"
                            type="text"
                            placeholder="Enter Covered Entity Name"
                            className="required"
                            autoComplete="off"
                            value={CoveredEntityName}
                            component={FormikInputField}
                            onChange={handelcoveredentityname}
                          />
                          {ceError ? (
                            <div className="text-danger f-12">
                              {ceError}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="opaid">OPA ID</Label>
                          <Input
                            className="required"
                            id="opaid"
                            name="opaid"
                            type="text"
                            placeholder="Enter OPA ID "
                            autoComplete="off"
                            value={opa}
                            component={FormikInputField}
                            onChange={handleOpaid}
                          />
                          {opaerror ? (
                            <div className="text-danger f-12">
                              {opaerror}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="Coveredentitytype">
                            Covered Entity Type
                          </Label>
                          <Field
                            className="required"
                            id="Coveredentitytype"
                            name="Coveredentitytype"
                            type='select'
                            placeholder="Enter Covered Entity Type "
                            autoComplete="off"
                            options={EntityType}
                            value={selectedCoverEntityType}
                            defaultoption='--Select--'
                            component={FormikSelectField}
                            onChange={handleCoverEntityType}
                            keys={{
                              id: 'id',
                              label: 'description',
                            }}
                          //  onChange={(e) =>handleCoverEntityType(e)}
                          />
                          {ceTypeError ? (
                            <div className="text-danger f-12">
                              {ceTypeError}
                            </div>
                          ) : null}

                        </FormGroup>
                      </Col>
                      <Col md={3} sm={3} xs={6}>
                        <Row>
                          <Col>
                            <FormGroup>
                              <Label>Live Date</Label>
                              <InputGroup
                                onMouseLeave={handleMouseLeave}
                              >
                                <Field
                                  className="required"
                                  // className="required"                                            
                                  // type="text"
                                  type="date"
                                  id="livedate"
                                  name="livedate"
                                  autoComplete="off"
                                  placeholder="Select a date"
                                  //  setcss='required'
                                  value={phLiveDate || ''}
                                  component={FormikDatePicker}
                                  onChange={handlePHLiveDate}
                                />
                                <InputGroupText
                                  onClick={() => handleDateClick('phLiveDate')}
                                >
                                  <img src={Calendar} alt="" />
                                </InputGroupText>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>

                    </Row>

                    <h4 className="f-15 text-primary font-weight-700 mt-3">
                      Address Information{" "}
                    </h4>

                    <Row sm={5}>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="Contactperson">
                            Contact Person
                          </Label>
                          <Input
                            className="required"
                            id="Contactperson"
                            name="Contactperson"
                            type="text"
                            placeholder="Enter ContactPerson Name"
                            autoComplete="off"
                            value={contactName}
                            component={FormikInputField}
                            onChange={handleContactName}
                          />
                          {contactError ? (
                            <div className="text-danger f-12">
                              {contactError}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="Address1">
                            Address 1
                          </Label>
                          <Input
                            className="required"
                            id="Address1"
                            name="Address1"
                            type="text"
                            placeholder="Enter Address"
                            autoComplete="off"
                            value={address1}
                            component={FormikInputField}
                            onChange={handleAddress1}
                          // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="Address2">
                            Address 2
                          </Label>
                          <Input
                            id="Address2"
                            name="Address2"
                            type="text"
                            placeholder="Enter Address"
                            autoComplete="off"
                            value={address2}
                            component={FormikInputField}
                            onChange={handleAddress2}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="City">
                            City
                          </Label>
                          <Input
                            // className="required"
                            id="City"
                            name="City"
                            type="text"
                            className="required"
                            placeholder="Enter City"
                            autoComplete="off"
                            value={cityName}
                            component={FormikInputField}
                            onChange={handleCityName}
                          // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6} >
                        {' '}
                        <FormGroup>
                          <Label for='state'>State</Label>
                          <Field
                            className="required"
                            id='state'
                            name='state'
                            type='select'
                            placeholder="Select State "
                            autoComplete='off'
                            options={state}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            optionSelected={true}
                            value={Selectedstate}
                            component={FormikSelectField}
                            // onChange={handleStateData}
                            defaultoption='--Select--'
                            keys={{
                              id: 'stateID',
                              label: 'stateName',
                            }}
                            onChange={(e) => handelStateChange(e)}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="zipcode">Zip Code</Label>
                          <Input
                            className="required"
                            id="zipcode"
                            name="zipcode"
                            type="text"
                            placeholder="Enter Zip Code "
                            autoComplete="off"
                            value={zipCode}
                            component={FormikInputField}
                            onChange={handleZipCode}
                          // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                          />
                          {zipcodeError ? (
                            <div className="text-danger f-12">
                              {zipcodeError}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="phoneno">Phone</Label>
                          <Input
                            className="required"
                            id="phoneno"
                            name="phoneno"
                            type="text"
                            placeholder="Enter Phone "
                            autoComplete="off"
                            value={phone}
                            component={FormikInputField}
                            onChange={handlePhone}
                          // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                          />
                          {phoneError ? (
                            <div className="text-danger f-12">
                              {phoneError}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="ext">Ext</Label>
                          <Input
                            id="ext"
                            name="ext"
                            type="text"
                            placeholder="Enter Ext "
                            autoComplete="off"
                            value={ext}
                            component={FormikInputField}
                            onChange={handleExt}
                          // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="fax">Fax</Label>
                          <Input
                            id="fax"
                            name="fax"
                            type="text"
                            placeholder="Enter Fax No "
                            autoComplete="off"
                            value={fax}
                            component={FormikInputField}
                            onChange={handleFax}
                          // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="Email">Email</Label>
                          <Input
                            className="required"
                            id="Email"
                            name="Email"
                            type="text"
                            placeholder="Enter Email Id "
                            autoComplete="off"
                            value={mail}
                            component={FormikInputField}
                            onChange={handleMailChange}
                          // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                          />
                          {emailError ? (
                            <div className="text-danger f-12">
                              {emailError}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="website">Website</Label>
                          <Input
                            id="website"
                            name="website"
                            type="text"
                            placeholder="Enter Website"
                            autoComplete="off"
                            value={website}
                            component={FormikInputField}
                            onChange={handleWebsite}
                          // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3} lg={3} sm={6} xs={6}>
                        {" "}
                        <FormGroup>
                          <Label for="Tollno">
                            Toll Free No
                          </Label>
                          <Input
                            id="Tollno"
                            name="Tollno"
                            type="text"
                            placeholder="Enter Toll Free No"
                            autoComplete="off"
                            value={tollFreeNo}
                            component={FormikInputField}
                            onChange={handleTollFreeNo}
                          // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Button
                          color="primary"
                          className="ms-3"
                          // onClick={handleSubmit}
                          //  onClick={addReset}
                          onClick={handelCancel}
                          style={{ float: "right" }}
                        // disabled = {addDisabled}                                        
                        >
                          Reset
                        </Button>
                        <Button
                          color="primary"
                          className="ms-3"
                          onClick={handleSubmit}
                          style={{ float: "right" }}
                          disabled={addDisabled}
                        >
                          Save
                        </Button>

                      </Col>
                    </Row>
                  </div>
                );
              }}></Formik>

          </CardBody>

        </Card>
      </Container>
    </div>
  )
}
export default AddPharmacyConfig;



